export const WAREHOUSES_ID_QUERY_NAME = 'wh-id';
export const WAREHOUSES_TYPE_QUERY_NAME = 'wh-type';
export const WAREHOUSES_BAGS_QUERY_NAME = 'bags'
